export const pagesAttendancesEn = {
  alerts: {
    actions: {
      attendanceGuidance: 'Attendance guidance',
      overtimeCorrective: 'Overtime corrective',
      toastDescription: 'This action is not available in the demo.',
      toastTitle: 'Action'
    },
    categories: {
      all: 'All',
      interval: 'Work interval',
      irregular: 'Attendance issues',
      leave: 'Leave usage',
      overtime: 'Overtime hours'
    },
    toolbar: {
      employeeChip: 'Employee',
      employmentTypeChip: 'Employment type',
      exportToastDescription: 'Export is not available in the demo.',
      exportToastTitle: 'Export',
      filterChip: 'Filter',
      fullscreenAria: 'Fullscreen',
      fullscreenToastDescription: 'Fullscreen is not available in the demo.',
      fullscreenToastTitle: 'Fullscreen',
      searchPlaceholder: 'Search…',
      shareAria: 'Share',
      shareToastDescription: 'Share is not available in the demo.',
      shareToastTitle: 'Share'
    },
    types: {
      annual_360h_exceeded: '360h annual exceeded',
      consecutive_overtime: 'Consecutive overtime',
      early_leave: 'Frequent early leave',
      holiday_work: 'Holiday work',
      interval_violation: 'Interval violation',
      late_arrival: 'Frequent late arrival',
      monthly_80h_exceeded: '80h monthly exceeded',
      no_clock_in: 'No clock-in',
      no_clock_out: 'No clock-out',
      overtime_limit: 'Overtime limit'
    }
  },
  clockingRecords: {
    approval: {
      approved: 'Approved',
      approvedBadge: 'Approved',
      pending: 'Pending',
      rejected: 'Rejected'
    },
    detail: {
      noRecords: 'No clocking records.'
    },
    employeeDetail: {
      attendanceBook: {
        attendanceStatusLabel: {
          absent: 'Absent',
          early_leave: 'Early leave',
          holiday: 'Holiday',
          late: 'Late',
          non_working_day: 'Non-working day',
          paid_leave: 'Paid leave',
          present: 'Present',
          sick_leave: 'Sick leave'
        },
        empty: 'Select a month to view the attendance book.',
        emptyFiltered: 'No rows match the current filters.',
        emptyPeriod: 'No attendance records for this period.',
        filters: {
          pendingOnly: 'Pending only',
          summaryVisible: 'Show summary'
        },
        summary: {
          absentDaysLabel: 'Absence days',
          earlyLeaveLabel: 'Early leave',
          lateLabel: 'Late arrivals',
          overtimeLabel: 'Overtime',
          paidLeaveDaysLabel: 'Paid leave days',
          remoteDaysLabel: 'Remote days',
          units: {
            times: 'times'
          },
          workingDaysLabel: 'Working days',
          workingDaysValue: '{{current}} / {{total}}',
          workingHoursLabel: 'Working hours'
        },
        workCategory: {
          absent: 'Absent',
          early_leave: 'Early leave',
          holiday: 'Holiday',
          late: 'Late',
          non_working_day: 'Non-working day',
          paid_leave: 'Paid leave',
          present: 'Work',
          sick_leave: 'Sick leave'
        }
      },
      breadcrumb: {
        attendances: 'Attendance book',
        clockingRecords: 'Attendance book list'
      },
      documentTitle: '{{name}} — Attendances',
      files: {
        actions: {
          back: 'Back',
          delete: 'Delete',
          deleteToastDescription: 'Delete is not available in the demo.',
          deleteToastTitle: 'Delete',
          download: 'Download',
          downloadToastDescription: 'Download is not available in the demo.',
          downloadToastTitle: 'Download',
          openFolder: 'Open {{folderName}}',
          previewToastDescription: 'Preview is not available in the demo.',
          previewToastTitle: 'Preview',
          rename: 'Rename',
          renameToastDescription: 'Rename is not available in the demo.',
          renameToastTitle: 'Rename'
        },
        columns: {
          fileCount: 'Files',
          fileName: 'File name',
          folder: 'Folder',
          owner: 'Member',
          updatedAt: 'Updated',
          uploadedBy: 'Uploaded by'
        },
        folders: {
          attendanceBook: 'Attendance book',
          leaveRequest: 'Leave requests',
          shiftTable: 'Shift schedule'
        },
        title: 'Files'
      },
      overview: {
        alertSummaryTitle: 'Unresolved alerts',
        emptyMembers: 'No data for this period.',
        kpi: {
          avgOvertime: 'Avg. overtime (per person)',
          members: 'Total attendees',
          totalWorkHours: 'Total working hours',
          unresolvedAlerts: 'Alerts to address'
        },
        overtimeRankingTitle: 'Overtime by member',
        selfSummaryTitle: 'This month',
        units: {
          cases: 'cases',
          hours: 'h',
          people: 'people'
        },
        viewAlerts: 'View alerts'
      },
      pageTitlePrefix: 'Attendance book:',
      scope: {
        ariaLabel: 'Switch attendance book target',
        selfHint: 'Your own attendance book',
        storeHint: 'Members working at your store',
        team: 'My team',
        teamHint: 'Members of your team'
      },
      tabPlaceholderSubtitle: 'This tab is not available in the demo.',
      tabPlaceholderTitle: 'Coming soon',
      tabs: {
        alerts: 'Alerts',
        attendanceBook: 'Attendance book',
        files: 'Files',
        overview: 'Overview',
        settings: 'Settings'
      },
      tabsAriaLabel: 'Employee attendance sections',
      toolbar: {
        exportPdfAria: 'Download PDF',
        exportPdfTooltip: 'Download PDF',
        exportToastDescription: 'PDF export is not available in the demo.',
        exportToastTitle: 'PDF',
        nextMonth: 'Next month',
        prevMonth: 'Previous month',
        selectPeriod: 'Select month'
      }
    },
    filters: {
      approvalAll: 'All approvals',
      employeeChip: 'Employee',
      employmentTypeChip: 'Employment type',
      filterChip: 'Filter',
      workplaceAll: 'All workplaces'
    },
    methods: {
      biometric: 'Biometric',
      ic_card: 'IC card',
      manual: 'Manual',
      mobile: 'Mobile',
      web: 'Web'
    },
    toolbar: {
      displayDaily: 'Daily',
      displayLabel: 'Display',
      export: 'Export',
      exportToastDescription: 'Export is not available in the demo.',
      exportToastTitle: 'Export',
      fullscreenAria: 'Fullscreen',
      fullscreenToastDescription: 'Fullscreen is not available in the demo.',
      fullscreenToastTitle: 'Fullscreen',
      nextMonth: 'Next month',
      prevMonth: 'Previous month',
      searchPlaceholder: 'Search…',
      selectPeriod: 'Select month'
    },
    types: {
      break_end: 'Break end',
      break_start: 'Break start',
      clock_in: 'Clock in',
      clock_out: 'Clock out'
    }
  },
  employees: {
    filterPlaceholder: 'Search by name…',
    organizationFilter: 'Organization',
    organizationSearchPlaceholder: 'Search organization…',
    statusFilter: {
      active: 'Active',
      all: 'All',
      on_leave: 'On leave',
      retired: 'Retirement scheduled'
    }
  },
  operationActivity: {
    activityTypes: {
      'alert.acknowledged': 'Alert acknowledged',
      'alert.resolved': 'Alert resolved',
      'alert.triggered': 'Alert triggered',
      'attendance.monthlyClosed': 'Monthly closed',
      'attendance.reopened': 'Monthly reopened',
      'clocking.approved': 'Clocking edit approved',
      'clocking.created': 'Clocking added',
      'clocking.deleted': 'Clocking deleted',
      'clocking.edited': 'Clocking edited',
      'clocking.rejected': 'Clocking edit rejected',
      'policy.attendanceStructureAssigned': 'Work structure assigned',
      'policy.ruleUpdated': 'Rule updated',
      'request.approved': 'Request approved',
      'request.cancelled': 'Request cancelled',
      'request.holidayWorkSubmitted': 'Holiday work request submitted',
      'request.leaveSubmitted': 'Leave request submitted',
      'request.overtimeSubmitted': 'Overtime request submitted',
      'request.rejected': 'Request rejected',
      'shift.assigned': 'Shift assigned'
    },
    actorSystem: 'System',
    categories: {
      alert: 'Alert',
      clocking: 'Clocking',
      policy: 'Rule / Shift',
      request: 'Request'
    },
    columns: {
      activityType: 'Activity',
      actor: 'Actor',
      detail: 'Detail',
      occurredAt: 'Occurred at',
      origin: 'Origin',
      target: 'Target employee'
    },
    filterByDate: 'Filter by date',
    originManual: 'Manual',
    pageTitle: 'Operation activity',
    showSummary: 'Show summary',
    summary: {
      alertsResolved: 'Alerts resolved',
      clockingCorrections: 'Clocking corrections',
      events: 'events',
      requestApprovals: 'Request approvals',
      targets: 'targets',
      thisMonth: 'This month',
      thisTerm: 'This term',
      thisWeek: 'This week'
    }
  },
  overview: {
    bands: {
      hourSuffix: 'h'
    },
    cards: {
      absenceRate: 'Absence rate',
      clockingGap: 'Clocking gap',
      longOvertime: 'Long overtime',
      monthlyOvertimeAverage: 'Monthly overtime (average)',
      monthlyOvertimeMedian: 'Monthly overtime (median)',
      paidLeaveUtilization: 'Paid leave utilization',
      remoteWorkRate: 'Remote work rate',
      sickLeaveRate: 'Sick leave rate'
    },
    loading: 'Loading…',
    offices: {
      fukuoka: 'Fukuoka',
      osaka: 'Osaka',
      sapporo: 'Sapporo',
      sendai: 'Sendai',
      tokyo_hq: 'Tokyo HQ'
    },
    organizations: {
      all: 'All organizations',
      searchPlaceholder: 'Search…'
    },
    overflowAria: '{{count}} more',
    periods: {
      fiscalYears: {
        fy2024: 'FY2024',
        fy2025: 'FY2025'
      },
      months: {
        feb: 'Feb 2026',
        jan: 'Jan 2026',
        mar: 'Mar 2026'
      },
      searchPlaceholder: 'Search…'
    },
    trend: {
      dailyAverage: 'Daily average',
      forecastEnd: 'Forecast end of month',
      markerDate: 'Day {{day}}',
      markerPrimary: '{{hours}} h',
      monthlyCap: 'Monthly cap {{hours}} h',
      title: 'Monthly overtime trend'
    },
    units: {
      hours: 'h',
      hoursShort: 'h',
      minutes: 'min',
      people: 'people',
      percent: '%'
    }
  },
  pageTitle: 'Time & Attendance Book',
  tabs: {
    alerts: 'Alerts',
    clockingRecords: 'Clocking records',
    employees: 'Employees',
    operationActivity: 'Operation activity',
    overview: 'Overview',
    ruleAndPolicy: 'Rule & Policy',
    settings: 'Settings'
  }
};